import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import AppPrint from './AppPrint';
import AppPage from './AppPage';

export default class extends Component {
  render() {
    return (
      <Switch>
        <Route path="/print" component={AppPrint} />
        <Route component={AppPage} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js